"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MobileMenuToggle_1 = __importDefault(require("../../components/MobileMenuToggle"));
MobileMenuToggle_1.default.getInstance();
